import { getThemeColor, onThemeChanged } from "./theme";

export function createInspectToolbar({ isActive, onToggle, onClose }) {
  const toolbar = document.createElement("a-entity");
  toolbar.setAttribute("class", "artwork-inspect-controls");
  toolbar.object3D.position.set(0, 0, 0.01);
  toolbar.object3D.matrixNeedsUpdate = true;
  toolbar.object3D.visible = false;
  const icons = [];
  let slash;
  const captions = [];

  const addButton = (x, icon, caption, action) => {
    const button = document.createElement("a-entity");
    const text = document.createElement("a-entity");
    text.setAttribute("text", { value: caption, fontSize: 0.033, textAlign: "center", anchorX: "center" });
    text.setAttribute("position", "0 -0.15 0.002");
    text.object3D.visible = false;
    text.setAttribute("text-raycast-hack", "");
    button.appendChild(text);
    captions.push(text);
    const image = document.createElement("a-entity");
    // Local geometry stays on the Inspect layer; the shared sprite batch does not.
    const symbol = new THREE.Group();
    if (icon === "hide-action.png") {
      const outline = new THREE.Mesh(
        new THREE.RingGeometry(0.76, 1, 32),
        new THREE.MeshBasicMaterial({ color: 0xffffff })
      );
      outline.scale.set(0.5, 0.3, 1);
      symbol.add(outline);
      symbol.add(new THREE.Mesh(new THREE.CircleGeometry(0.16, 24), new THREE.MeshBasicMaterial({ color: 0xffffff })));
      slash = new THREE.Mesh(new THREE.PlaneGeometry(1.15, 0.12), new THREE.MeshBasicMaterial({ color: 0xffffff }));
      slash.rotation.z = -Math.PI / 4;
      slash.position.z = 0.01;
      symbol.add(slash);
    } else {
      for (const angle of [-Math.PI / 4, Math.PI / 4]) {
        const stroke = new THREE.Mesh(
          new THREE.PlaneGeometry(0.95, 0.12),
          new THREE.MeshBasicMaterial({ color: 0xffffff })
        );
        stroke.rotation.z = angle;
        symbol.add(stroke);
      }
    }
    symbol.traverse(object => {
      object.raycast = () => {};
    });
    image.setObject3D("mesh", symbol);
    icons.push(symbol);
    image.setAttribute("scale", "0.100 0.100 0.100");
    image.setAttribute("position", "0 0 0.002");
    button.appendChild(image);
    button.setAttribute("class", "ui artwork-inspect-control");
    button.setAttribute("mixin", "rounded-action-button");
    button.setAttribute("slice9", "side: front");
    button.setAttribute("scale", "0.75 0.75 0.75");

    button.setAttribute("is-remote-hover-target", "");
    button.setAttribute("tags", { singleActionButton: true });
    button.object3D.position.set(x, 0, 0);
    button.object3D.matrixNeedsUpdate = true;
    button.object3D.addEventListener("hovered", () => {
      text.object3D.visible = true;
    });
    button.object3D.addEventListener("unhovered", () => {
      text.object3D.visible = false;
    });
    button.object3D.addEventListener("interact", () => {
      if (isActive()) action();
    });
    toolbar.appendChild(button);
    return text;
  };

  const caption = addButton(-0.15, "hide-action.png", "Show Verse", onToggle);
  addButton(0.15, "close-action.png", "Close", onClose);
  const applyTheme = () => {
    const foreground = getThemeColor("text-primary");
    for (const icon of icons)
      icon.traverse(object => {
        if (object.material) object.material.color.set(foreground);
      });
    for (const text of captions) text.setAttribute("text", "color", foreground);
  };
  applyTheme();
  const removeThemeListener = onThemeChanged(applyTheme);
  let previousLightsEnabled;
  return {
    el: toolbar,
    caption,
    slash,
    icons,
    update(lightsEnabled) {
      if (previousLightsEnabled === lightsEnabled) return;
      previousLightsEnabled = lightsEnabled;
      caption.setAttribute("text", "value", lightsEnabled ? "Focus view" : "Show Verse");
      slash.visible = !lightsEnabled;
    },
    dispose() {
      removeThemeListener();
      for (const icon of icons)
        icon.traverse(object => {
          object.geometry?.dispose();
          object.material?.dispose();
        });
      toolbar.remove();
    }
  };
}
